'use strict';

var WeeklyCtrl = function ($scope,
                                 $state,
                                 $stateParams,
                                 employee,
                                 gettextCatalog,
                                 office,
                                 services,
                                 Notification,
                                 moment,
                                 ResourceDA) {
  this.gettextCatalog = gettextCatalog;
  this._Notification = Notification;
  this._ResourceDA = ResourceDA;
  this._state = $state;
  this._stateParams = $stateParams;
  this._moment = moment;

  this.employee = employee;
  this.weekDays = [];
  this.office = office;
  this.serviceWorkingHourIndex = -1;
  this.weekValidation = [
    {valid: true, invalidTimeIndex: -1},
    {valid: true, invalidTimeIndex: -1},
    {valid: true, invalidTimeIndex: -1},
    {valid: true, invalidTimeIndex: -1},
    {valid: true, invalidTimeIndex: -1},
    {valid: true, invalidTimeIndex: -1},
    {valid: true, invalidTimeIndex: -1}
  ];
  this.serviceName = '';

  $scope.$on('t2g:shift-planning:save:clicked', () => {
    this.saveWeekly();
  });

  if ($stateParams.serviceId) {
    this.serviceWorkingHourIndex = employee.serviceWorkingHours.findIndex((serviceWorkingHour) => serviceWorkingHour.serviceId === $stateParams.serviceId);
    this.workingHoursRef = employee.serviceWorkingHours[this.serviceWorkingHourIndex].hours;
    this.serviceName = services[$stateParams.serviceId].label;
  } else {
    this.workingHoursRef = employee.workingHours;
  }
};

/**
 * copy opening hours to working hours
 */
WeeklyCtrl.prototype.applyOpeningHours = function () {
  var self = this;

  _.forEach(this.office.openingHours.regular, function (openingHour, index) {
    var workingHour = self.workingHoursRef[index];
    workingHour.available = openingHour.open;
    workingHour.times = openingHour.times;
  });
};

/**
 * save weekly working hours (shifts)
 */
WeeklyCtrl.prototype.saveWeekly = function () {
  var self = this;

  let valid = true;
  this.weekValidation = [
    {valid: true, invalidTimeIndex: -1},
    {valid: true, invalidTimeIndex: -1},
    {valid: true, invalidTimeIndex: -1},
    {valid: true, invalidTimeIndex: -1},
    {valid: true, invalidTimeIndex: -1},
    {valid: true, invalidTimeIndex: -1},
    {valid: true, invalidTimeIndex: -1}
  ];

  // validate input
  this.workingHoursRef.forEach((day, dayIndex) => {
    if (day.available && day.times) {
      day.times.forEach((time, timeIndex) => {
        if (time.end <= time.start) {
          this.weekValidation[dayIndex].valid = false;
          this.weekValidation[dayIndex].invalidTimeIndex = timeIndex;
          valid = false;
        }

        if (timeIndex > 0) {
          if (time.start <= day.times[timeIndex - 1].end) {
            this.weekValidation[dayIndex].valid = false;
            this.weekValidation[dayIndex].invalidTimeIndex = timeIndex;
            valid = false;
          }
        }
      });
    }
  });

  if(!valid) {
    this._Notification.addErrorMessage(self.gettextCatalog.getString('Please check the marked times. Start and End time are overlapping'));
  } else {
    let update = {_id: this.employee._id};

    if (this._stateParams.serviceId) {
      update.serviceWorkingHours = this.employee.serviceWorkingHours;
    } else {
      update.workingHours = this.workingHoursRef;
    }

    this._ResourceDA.update(update)
        .then(
            function () {
              self._Notification.addSuccessMessage(self.gettextCatalog.getString('Working hours saved'));
            },
            function (error) {
              self._Notification.addErrorMessage(self.gettextCatalog.getString('Cant save working hours (Error: {{error}})', {error: error}));
            }
        );
  }
};

/**
 * helper function for ng-repeat (repeat x times)
 * @param {Number} num
 * @returns {Array}
 */
WeeklyCtrl.prototype.getNumber = function (num) {
  return new Array(num);
};


/**
 * shorthand for availability of a weekly planning day
 * @param {Number} index
 */
WeeklyCtrl.prototype.isAvailableWH = function (index) {
  var workingHours = this.workingHoursRef[index];
  return workingHours ? workingHours.available : false;
};


/**
 * add weekly secondary time
 * @param {Number} dayIndex
 * @param {Number} timeIndex
 * @param {Boolean} before
 */
WeeklyCtrl.prototype.addWeeklyTime = function (dayIndex, timeIndex, before) {
  const currentTime = this.workingHoursRef[dayIndex].times[timeIndex];
  const insertIndex = before ? timeIndex : timeIndex + 1;
  let start = 0;
  let end = 1440;

  if (before) {
    end = Math.max(0, currentTime.start - 30);

    if (timeIndex > 0) {
      const beforeTime = this.workingHoursRef[dayIndex].times[timeIndex - 1];
      start = Math.max(0, beforeTime.end);
    } else{
      start = Math.max(0, end - 60);
    }
  } else {
    start = currentTime.end + 30;
    end = Math.min(1440, start + 60);
  }

  this.workingHoursRef[dayIndex].times.splice(insertIndex, 0, { start, end});
};


/**
 * remove weekly secondary time
 * @param {Number} index
 */
WeeklyCtrl.prototype.removeWeeklyTime = function (dayIndex, timeIndex) {
  this.workingHoursRef[dayIndex].times.splice(timeIndex, 1);
};

module.exports = WeeklyCtrl;
